/* 
* <license header>
*/

/**
 * Pages - Route-level components that occupy full screens
 * These are stateful components connected to routes in App.tsx
 */

// Landing pages
export { Home } from './Home'
export { About } from './About'

// User pages
export { UserProfile } from './UserProfile'

// Dashboard pages
export { EventsDashboard } from './EventsDashboard'
export { SeriesDashboard } from './SeriesDashboard'
export { Registrations } from './Registrations'
export { SpeakersDashboard } from './SpeakersDashboard'
export { OverviewDashboard } from './OverviewDashboard'

// Form pages
export { EventForm } from './EventForm'
export { SeriesForm } from './SeriesForm'

// Admin pages
export { UserManagement } from './UserManagement'
export { ScopeGroupManagement } from './ScopeGroupManagement'
export { RoleManagement } from './RoleManagement'
export { ConfigManagement } from './ConfigManagement'
